

const menu = [
  {
    title: 'Bo bun',
    price: '9.50€',
  },
  {
    title: 'Bol à composer',
    price: '9.90€',
    tags: '(riz/nouille + Boeuf/Poulet + 2 Nems)',
  },
  {
    title: 'Soupe de nouille',
    price: '10.00€',
  },
  {
    title: 'Pad Thai',
    price: '10.00€',
  },
  {
    title: 'Menu Dim Sun',
    price: '10.50€',
    tags: '(7 vapeurs/nems + riz/nouille)',
  },
  {
    title: 'Barquette sushi',
    price: '10.90€',
  },
  {
    title: 'Poké Bowl',
    price: '10.90€',
  },
  {
    title: 'Menu spécial',
    price: '11.90€',
    tags: ' (riz/nouille + boeuf/poulet/crevette/légumes + 3 nems/vapeurs + 1 boisson/dessert)',
  },
];

export default { menu };
